import { render } from "./IniziaRilevazione.vue?vue&type=template&id=48f7b9cc&scoped=true"
import script from "./IniziaRilevazione.vue?vue&type=script&lang=js"
export * from "./IniziaRilevazione.vue?vue&type=script&lang=js"

import "./IniziaRilevazione.vue?vue&type=style&index=0&id=48f7b9cc&lang=scss&scoped=true"
import "./IniziaRilevazione.vue?vue&type=style&index=1&id=48f7b9cc&lang=scss"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f7b9cc"]])

export default __exports__